import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@kolmeo/ui-core";
import RadioButton from "./RadioButton";
const RadioGroup = ({ options, onSelect, selectedValue }) => {
    return (_jsx(Box, { accessibilityRole: "radiogroup", children: options.map((option) => (_jsx(RadioButton, { isSelected: selectedValue === option.value, label: option.label, onSelect: () => onSelect(option.value), subtitle: option.subtitle, secondaryComponent: option.secondaryComponent, showSecondaryOnSelect: option.showSecondaryOnSelect }, option.value))) }));
};
export default RadioGroup;
